export default __webpack_public_path__ + "static/media/use8.3a5e3b97.png";